import React, { useState, useEffect } from 'react';
import {
    useStripe,
    useElements,
    CardElement,
    PaymentRequestButtonElement,
} from '@stripe/react-stripe-js';

const PaymentModal = ({ clientSecret }) => {
    const stripe = useStripe();
    const elements = useElements();
    // console.log(':stripe',stripe) 

    const [method, setMethod] = useState("apple");
    const [paymentRequest, setPaymentRequest] = useState(null);
    const [canMakePayment, setCanMakePayment] = useState(false);

    useEffect(() => {
        // alert("useEffect clientSecret: " + clientSecret);
        if (!stripe) return;

        const pr = stripe.paymentRequest({
            country: "GB",
            currency: "gbp",
            total: {
                label: "Total",
                amount: 1000,
            },
            // requestPayerName: true,
            // requestPayerEmail: true,
            // supportedPaymentMethods: ['card']
            supportedPaymentMethods: [
                {
                    supportedMethods: "apple_pay",
                    data: {
                        environment: "TEST", // or "PRODUCTION"
                        apiVersion: 2,
                        apiVersionMinor: 0,
                        merchantInfo: {
                            merchantName: "Example Merchant"
                        },
                        allowedPaymentMethods: [
                            {
                                type: "CARD",
                                parameters: {
                                    allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                                    allowedCardNetworks: ["MASTERCARD", "VISA"]
                                },
                                tokenizationSpecification: {
                                    type: "PAYMENT_GATEWAY",
                                    parameters: {
                                        gateway: "stripe",
                                        "stripe:version": "2025-06-30.basil",
                                        "stripe:publishableKey": "pk_test_51RaWtSRlNSeW37Lx4InYacEK5tILGtJ9Ao42SJCFQI1sYjmlUZlgDMgt4RAdtRayQV8uAdwBkOGPqSr8uIgRgDsT00wWea9Vy3" // your Stripe key
                                    }
                                }
                            }
                        ]
                    }
                }
            ]
        });

        console.log(':::::useEffect:::pr::', pr)
        pr.canMakePayment().then((result) => {
            console.log(':::::useEffect:::result::', result)
            if (result) {
                setCanMakePayment(true);
                setPaymentRequest(pr);
            }
        });
    }, [stripe]);

    useEffect(() => {
        if (!paymentRequest || !stripe) return;
        console.log(':::::useEffect:::stripe,paymentRequest::', { stripe, paymentRequest })
        // paymentRequest.on("paymentmethod", async (ev) => {
        //     const { error } = await stripe.confirmCardPayment(clientSecret, {
        //         payment_method: ev.paymentMethod.id,
        //     });

        //     if (error) {
        //         ev.complete("fail");
        //         alert('shiv test');
        //     } else {
        //         ev.complete("success");
        //         alert("Payment successful");
        //     }
        // });
        paymentRequest.on("paymentmethod", async (ev) => {
            if (!clientSecret) {
                console.error("Missing clientSecret");
                alert("Payment failed: Missing client secret.");
                ev.complete("fail");
                return;
            }
alert("Payment clientSecret: " + ev.paymentMethod.id);
// alert("Payment stringify: " + JSON.stringify(ev));
            const { error } = await stripe.confirmCardPayment(clientSecret, {
                payment_method: ev.paymentMethod.id,
                
            },{
        handleActions: false,
      });
            // alert("Payment paymentMethod: " + ev.paymentMethod.id);

            if (error) {
                console.error("Stripe error:", error);
                ev.complete("fail");
                alert("Payment failed: " + JSON.stringify(error));
            } else {
                ev.complete("success");
                alert("Payment successful");
            }
        });
    }, [paymentRequest]);

    const handleCardSubmit = async (e) => {
        e.preventDefault();
        if (!stripe || !elements) return;

        const cardElement = elements.getElement(CardElement);
        const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
            payment_method: {
                card: cardElement,
                billing_details: {
                    name: "Card Holder", // optional
                },
            },
        });

        if (error) {
            alert('shiv');
        } else if (paymentIntent.status === "succeeded") {
            alert("Card payment succeeded!");
        }
    };

    return (
        <div className="payment-modal">
            <h3>Select Payment Method</h3>
            <div className="radio-group">
                <label>
                    <input
                        type="radio"
                        name="method"
                        value="card"
                        checked={method === "card"}
                        onChange={(e) => setMethod(e.target.value)}
                    />
                    Credit / Debit Card
                </label>
                {/* <label>
                    <input
                        type="radio"
                        name="method"
                        value="apple"
                        checked={method === "apple"}
                        onChange={(e) => console.log(e.target.value)}
                        disabled={!canMakePayment}
                    />
                    Apple Pay
                </label>
                <label>
                    <input
                        type="radio"
                        name="method"
                        value="google"
                        checked={method === "google"}
                        onChange={(e) => setMethod(e.target.value)}
                        disabled={!canMakePayment}
                    />
                    Google Pay
                </label> */}
            </div>

            {method === "card" && (
                <form onSubmit={handleCardSubmit}>
                    <CardElement options={{ hidePostalCode: false }} />
                    <input placeholder="Cardholder name" />
                    <button type="submit" disabled={!stripe}>Pay</button>
                </form>
            )}

            {(method === "apple" || method === "google") && canMakePayment && (
                <div style={{ marginTop: 20 }}>
                    <PaymentRequestButtonElement
                        options={{
                            paymentRequest,
                            style: {
                                paymentRequestButton: {
                                    type: "default",
                                    theme: "light-outline",
                                    height: "44px",
                                },
                            },
                        }}
                    />
                </div>
            )}

            {!canMakePayment && method !== "card" && (
                <p>This device/browser doesn't support Apple Pay or Google Pay</p>
            )}
        </div>
    );
};

export default PaymentModal;
